import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

export const ProductSelectionContainer = styled(Box)(({ theme }) => ({
  // Contenedor principal
}));

export const ProductFormsContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const AddButton = styled(Button)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1.25, 2),
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#7c3aed',
  backgroundColor: 'transparent',
  border: `1px dashed ${theme.palette.divider}`,
  borderRadius: '12px',
  textTransform: 'none',
  marginTop: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: 'rgba(124, 58, 237, 0.08)',
    borderColor: '#7c3aed',
    color: '#6d28d9',
    borderStyle: 'solid',
  },
  '&:active': {
    transform: 'scale(0.98)',
  },
  '&:focus': {
    outline: 'none',
    boxShadow: '0 0 0 3px rgba(124, 58, 237, 0.2)',
  },
  '&:disabled': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.disabled,
    borderColor: theme.palette.divider,
    cursor: 'not-allowed',
  },
}));

export const AddButtonIcon = styled('svg')(({ theme }) => ({
  width: '1.125rem',
  height: '1.125rem',
  color: 'currentColor',
  transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'rotate(90deg)',
  },
}));

export const ValidationStats = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.25, 2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: '10px',
  border: `1px solid ${theme.palette.divider}`,
  marginTop: theme.spacing(1.5),
  textAlign: 'center',
}));

export const ValidationTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.8125rem',
  fontWeight: 500,
  color: theme.palette.text.secondary,
  margin: 0,
}));

export const ValidationStatsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
  gap: theme.spacing(1),
}));

export const StatItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
}));

export const StatValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem', // text-xl
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
}));

export const StatLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem', // text-xs
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 3),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  border: `1px dashed ${theme.palette.divider}`,
}));

export const EmptyStateIcon = styled('svg')(({ theme }) => ({
  width: '3.5rem',
  height: '3.5rem',
  color: theme.palette.grey[400],
  marginBottom: theme.spacing(2),
  opacity: 0.6,
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.75),
}));

export const EmptyStateDescription = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.secondary,
  opacity: 0.7,
  lineHeight: 1.5,
}));

export const ErrorState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.25, 2),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.error.main,
  borderRadius: '10px',
  border: `1px solid ${theme.palette.error.light}`,
  marginTop: theme.spacing(1.5),
  textAlign: 'center',
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  fontSize: '0.8125rem',
  fontWeight: 400,
  color: theme.palette.error.main,
}));

export const SupplierSelectorContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: '100%',
}));
